import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from "../../assets/images/logo/dodeal-white.png";
import useFadeInOnScroll from '../Effects/FadeInOnScroll';

function SiteFooter() {
    useFadeInOnScroll();

    const navigate = useNavigate();

    const currentYear = new Date().getFullYear();

    const redirectToPrivacyPolicy = () => {
        navigate("/privacypolicy");
    };
    return (
        <div
            dir="ltr"
            className="relative w-full flex flex-col gap-4"
            style={{
                zIndex: 12,
                padding: "30px 7%",
                borderRadius: "20px 20px 0px 0px",
                background: "linear-gradient(133.7deg, rgba(255, 255, 255, 0.2) -3.49%, rgba(116, 159, 237, 0.2) 128.73%)",
                // border: "0.5px solid",
                borderImageSource: "linear-gradient(165.4deg, rgba(0, 0, 0, 0.2) -10.07%, rgba(255, 255, 255, 0) 89.61%)",
                // borderRadius: "20px",
                // borderWidth: "0.5px",
                mixBlendMode: "Lighten",
                backdropFilter: "blur(14px)"
            }}
        >
            <div className="flex">
                <img src={logo} className="fade-element w-[100px]" />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-4 gap-6 py-5 my-5">
                <div className="flex w-full lg:justify-center mb-4">
                    <div className="flex flex-col gap-2">
                        <div className="text-lg uppercase">
                            Services
                        </div>
                        <div className="flex flex-wrap lg:flex-col sm:items-center md:items-center sm:justify-center md:justify-center gap-x-5 gap-y-2 lg:gap-2">
                            <div className="cursor-pointer w-full" onClick={() => navigate(`/services/dodeal-crm`)}>
                                DoDeal CRM
                            </div>
                            <div className="cursor-pointer w-full" onClick={() => navigate(`/services/digital-marketing`)}>
                                Digital Marketing
                            </div>
                            <div className="cursor-pointer w-full" onClick={() => navigate(`/services/creative-services`)}>
                                Creative Services
                            </div>
                            <div className="cursor-pointer w-full" onClick={() => navigate(`/services/advertising-and-campaigns`)}>
                                Advertising & Campaigns
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex w-full lg:justify-center mb-4">
                    <div className="flex flex-col gap-2">
                        <div className="text-lg uppercase">
                            Quick Links
                        </div>
                        <div className="flex flex-wrap lg:flex-col sm:items-center md:items-center sm:justify-center md:justify-center gap-x-5 gap-y-2 lg:gap-2">
                            {/* <div>
                                Portfolio
                            </div> */}
                            <div className="cursor-pointer w-full" onClick={() => navigate(`/`)}>
                                Home
                            </div>
                            <div className="cursor-pointer w-full" onClick={() => navigate(`/services`)}>
                                Services
                            </div>
                            <div className="cursor-pointer w-full" onClick={() => navigate(`/about`)}>
                                About
                            </div>
                            <div className="cursor-pointer w-full" onClick={() => navigate(`/blogs`)}>
                                Latest
                            </div>
                            <div className="cursor-pointer w-full" onClick={() => navigate(`/web-mobile-apps`)}>
                                Connect
                            </div>
                        </div>
                    </div>
                </div>
                <div className="flex w-full lg:justify-center mb-4">
                    <div className="flex flex-col gap-2">
                        <div className="text-lg uppercase">
                            phone
                        </div>
                        <div>
                            +971 4 262 1133
                        </div>
                        <br />
                        <div className="text-lg uppercase">
                            email
                        </div>
                        <div>
                            contact@dodeal.com
                        </div>
                    </div>
                </div>
                <div className="flex w-full lg:justify-center mb-4">
                    <div className="flex flex-col gap-2">
                        <div className="text-lg uppercase">
                            Visit us
                        </div>
                        <div>
                            1610, SIT Tower, Dubai Silicon Oasis, Dubai, United Arab Emirates
                        </div>
                        <div>
                            51, 3 Skies Plaza Mall, 90th Street, 5th Settlement, New Cairo, Egypt
                        </div>
                    </div>
                </div>
            </div>
            <div className="flex flex-wrap gap-1 items-center justify-center w-full">
                <span className="text-white">
                    © {currentYear}
                </span>
                <span className="primary-text font-bold">
                    DODEAL
                </span>
                <span>|</span>
                <span>All Rights Reserved </span>
                <span>|</span>
                <span
                    onClick={redirectToPrivacyPolicy}
                >
                    Privacy Policy
                </span>
            </div>
        </div>
    );
}

export default SiteFooter;
